var __merlinGlobal = (typeof window !== 'undefined' ? window : globalThis);
var __merlinTrustedTypes = __merlinGlobal.MerlinTrustedTypes || (__merlinGlobal.MerlinTrustedTypes = (function() {
    function safeSetInnerHTML(element, html) {
        if (!element) return;
        if (!html) {
            element.replaceChildren();
            return;
        }

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        element.replaceChildren();
        Array.from(doc.body.childNodes).forEach(function(node) {
            element.appendChild(document.adoptNode(node));
        });
    }

    function safeInsertAdjacentHTML(element, position, html) {
        if (!element || !html) return;

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        var fragment = document.createDocumentFragment();
        Array.from(doc.body.childNodes).forEach(function(node) {
            fragment.appendChild(document.adoptNode(node));
        });

        switch (position) {
            case 'beforeend':
                element.appendChild(fragment);
                break;
            case 'afterbegin':
                element.prepend(fragment);
                break;
            case 'beforebegin':
                element.before(fragment);
                break;
            case 'afterend':
                element.after(fragment);
                break;
        }
    }

    return {
        safeSetInnerHTML: safeSetInnerHTML,
        safeInsertAdjacentHTML: safeInsertAdjacentHTML
    };
})());
var safeSetInnerHTML = __merlinTrustedTypes.safeSetInnerHTML;
var safeInsertAdjacentHTML = __merlinTrustedTypes.safeInsertAdjacentHTML;
/**
 * Graph Explorer - Toolbar Module
 * Handles left toolbar and right global toolbar interactions
 */

(function(global) {
    'use strict';

    let leftToolbar, rightToolbar, hamburgerBtn, drawerOpen = false;
    let eventsBound = false;  // Prevent duplicate event binding on reinit

    // ============================================
    // Right Toolbar Button Definitions (Global - visible on ALL tabs)
    // Organized into sections: View, Layout, Data
    // ============================================
    const rightButtons = [
        // View section - Theme only (Reset moved to cursor toolbar in explorer-tasks.js)
        { section: 'view', sectionClass: 'toolbar-section-view', buttons: [
            { id: 'btn-theme', icon: 'moon', label: 'Toggle theme', shortcut: 'T', action: 'theme', toggle: true }
        ]},
        // Layout section - Physics and layout controls
        { section: 'layout', sectionClass: 'toolbar-section-layout', buttons: [
            { id: 'btn-physics', icon: 'zap', label: 'Physics', shortcut: 'P', action: 'physics', toggle: true, active: true },
            { id: 'btn-performance-mode', icon: 'gauge', label: 'Performance mode', action: 'performanceMode', toggle: true },
            { id: 'btn-layout', icon: 'layout-grid', label: 'Improve layout', shortcut: 'I', action: 'layout' },
            { id: 'btn-fit', icon: 'maximize-2', label: 'Fit to screen', shortcut: 'F', action: 'fit' }
        ]},
        // Data section - FQL, Reload, Export, Extended Edges
        { section: 'data', sectionClass: 'toolbar-section-data', buttons: [
            { id: 'btn-fql', icon: 'code', label: 'FQL Editor', shortcut: 'Q', action: 'fqlWindow', toggle: true },
            { id: 'btn-reload', icon: 'refresh-cw', label: 'Reload data', shortcut: 'Shift+R', action: 'reload' },
            { id: 'btn-rebuild', icon: 'hammer', label: 'Rebuild graph', action: 'rebuild' },
            { id: 'btn-extended-edges', icon: 'git-branch', label: 'Extended edges', action: 'extendedEdges', toggle: true },
            { id: 'btn-export', icon: 'download', label: 'Export', shortcut: 'Ctrl+E', action: 'exportPanel' }
        ]},
        // Appearance section - Settings and Legend (moved from left toolbar)
        { section: 'appearance', sectionClass: 'toolbar-section-appearance', buttons: [
            { id: 'btn-settings', icon: 'sliders-horizontal', label: 'Settings', shortcut: 'C', action: 'settingsWindow', toggle: true },
            { id: 'btn-legend', icon: 'palette', label: 'Legend', shortcut: 'G', action: 'legendWindow', toggle: true }
        ]}
    ];

    // ============================================
    // Left Toolbar Button Definitions (Tab-specific)
    // ============================================
    const leftButtons = [
        // Base section - visible on Graph and Bookmarks tabs (checkpoints & bookmarks creation)
        { section: 'base', sectionClass: 'toolbar-base toolbar-graph-bookmarks', buttons: [
            { id: 'btn-create-checkpoint', icon: 'flag', label: 'Create checkpoint', action: 'createCheckpoint' },
            { id: 'btn-create-bookmark', icon: 'bookmark-plus', label: 'Create bookmark', action: 'createBookmark' },
            { id: 'btn-clear', icon: 'eraser', label: 'Clear view', action: 'clearView' }
        ]},
        // NOTE: checkpoint/bookmark LISTS are now rendered in the bottom sub-tabs bar
        //       managed by ExplorerTabs.setCheckpoints / setBookmarks

        // Windows section - Graph tab only
        { section: 'windows-graph', sectionClass: 'toolbar-graph-only', buttons: [
            { id: 'btn-explorer', icon: 'text-search', label: 'Search & Find', shortcut: 'Ctrl+K', action: 'explorerWindow', toggle: true },
            { id: 'btn-aliases', icon: 'link-2', label: 'Aliases', shortcut: 'A', action: 'aliasesWindow', toggle: true },
            { id: 'btn-selection', icon: 'info', label: 'Selection & Operators', shortcut: 'S', action: 'selectionWindow', toggle: true },
            { id: 'btn-patterns', icon: 'shapes', label: 'Patterns', shortcut: 'Ctrl+Shift+P', action: 'patternsWindow', toggle: true }
        ]},
        // Performance section - Graph tab only: Clustering
        { section: 'perf-graph', sectionClass: 'toolbar-graph-only', buttons: [
            { id: 'btn-cluster', icon: 'group', label: 'Cluster', shortcut: 'C', action: 'cluster', toggle: true }
        ]},
        // Windows section - Bookmarks tab only (unified Find & Select)
        { section: 'windows-bookmarks', sectionClass: 'toolbar-bookmarks-only', hidden: true, buttons: [
            { id: 'btn-findselect-bm', icon: 'search', label: 'Find & Select', shortcut: '/', action: 'findSelectWindow', toggle: true }
        ]},
        // Windows section - Bookmarks tab only: Algorithms, Functions, Documents
        { section: 'windows-shared', sectionClass: 'toolbar-bookmarks-only', hidden: true, buttons: [
            { id: 'btn-algorithms', icon: 'cpu', label: 'Algorithms', shortcut: 'K', action: 'algorithmsWindow', toggle: true },
            { id: 'btn-functions', icon: 'lightbulb', label: 'Functions', shortcut: 'N', action: 'functionsWindow', toggle: true },
            { id: 'btn-documents', icon: 'file-text', label: 'Documents', shortcut: 'D', action: 'documentsWindow', toggle: true }
        ]},
        // Timeline section - Create button and list
        { section: 'timeline-base', sectionClass: 'toolbar-timeline-only', hidden: true, buttons: [
            { id: 'btn-create-timeline', icon: 'plus', label: 'Create Timeline', shortcut: 'Ctrl+N', action: 'createTimeline' }
        ]},
        // Dynamic timelines list - Timeline tab only
        { section: 'timelines-list', sectionClass: 'toolbar-timeline-only toolbar-timelines-section', hidden: true, buttons: [] },
        // Analytics section - Create button and list
        { section: 'analytics-base', sectionClass: 'toolbar-analytics-only', hidden: true, buttons: [
            { id: 'btn-create-analytics', icon: 'plus', label: 'Create Analytics', shortcut: 'Ctrl+N', action: 'createAnalytics' }
        ]},
        // Dynamic analytics list - Analytics tab only
        { section: 'analytics-list', sectionClass: 'toolbar-analytics-only toolbar-analytics-section', hidden: true, buttons: [] },
        // Artefacts section - Templates button
        { section: 'artefacts-base', sectionClass: 'toolbar-artefacts-only', hidden: true, buttons: [
            { id: 'btn-browse-templates', icon: 'layout-template', label: 'Browse Templates', shortcut: 'T', action: 'browseTemplates' }
        ]},
        // Dynamic artefacts list - Artefacts tab only
        { section: 'artefacts-list', sectionClass: 'toolbar-artefacts-only toolbar-artefacts-section', hidden: true, buttons: [] }
    ];

    // Dynamic lists for checkpoints and bookmarks
    let checkpointsList = [];
    let bookmarksList = [];
    // Dynamic lists for timelines and analytics queries
    let timelinesList = [];
    let analyticsList = [];
    // Dynamic list for artefacts
    let artefactsList = [];

    // Active toolbar button definitions (may be overridden by ui_mode preset)
    let activeLeftButtons = leftButtons;
    let activeRightButtons = rightButtons;

    // ============================================
    // Initialization
    // ============================================
    function init(options = {}) {
        if (options.left) {
            activeLeftButtons = options.left;
        }
        if (options.right) {
            activeRightButtons = options.right;
        }

        // Get existing toolbar elements (rendered by Jinja template)
        leftToolbar = document.getElementById('toolbar-left');
        rightToolbar = document.getElementById('toolbar-right');
        hamburgerBtn = document.getElementById('hamburger-btn');
        
        // If left toolbar doesn't exist, create it dynamically (standalone mode)
        if (!leftToolbar) {
            createLeftToolbar();
        }
        
        // Create right toolbar (global toolbar) if it doesn't exist or recreate it
        if (!rightToolbar || rightToolbar.children.length === 0) {
            createRightToolbar();
        }
        
        // Bind events to existing buttons
        bindEvents();

        if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.getPerformanceMode) {
            setButtonActive('btn-performance-mode', ExplorerAPI.getPerformanceMode() === 'large');
        }
        
        console.log('[ExplorerToolbar] Initialized');
    }
    
    /**
     * Create the left toolbar dynamically (for standalone/bundled mode)
     */
    function createLeftToolbar() {
        // Find container - either #toolbar-container or .graph-explorer
        const container = document.getElementById('toolbar-container') || document.querySelector('.graph-explorer');
        if (!container) {
            console.warn('[ExplorerToolbar] No container found for toolbar');
            return;
        }
        
        // Create toolbar element
        leftToolbar = document.createElement('nav');
        leftToolbar.id = 'toolbar-left';
        leftToolbar.className = 'toolbar toolbar-left';
        leftToolbar.setAttribute('role', 'toolbar');
        leftToolbar.setAttribute('aria-label', 'Graph controls');
        
        // Render buttons
        safeSetInnerHTML(leftToolbar, renderToolbarButtons(activeLeftButtons));
        
        // Insert into container
        if (container.id === 'toolbar-container') {
            container.appendChild(leftToolbar);
        } else {
            // Insert at start of .graph-explorer
            container.insertBefore(leftToolbar, container.firstChild);
        }
        
        // Create Lucide icons if available
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 10);
        }
        
        console.log('[ExplorerToolbar] Created left toolbar dynamically');
    }
    
    /**
     * Create the right toolbar (global toolbar) dynamically
     * This toolbar is positioned at the top right and visible on ALL tabs
     */
    function createRightToolbar() {
        // Find container - either #toolbar-container or .graph-explorer
        const container = document.getElementById('toolbar-container') || document.querySelector('.graph-explorer');
        if (!container) {
            console.warn('[ExplorerToolbar] No container found for right toolbar');
            return;
        }
        
        // Remove existing right toolbar if any
        const existingRight = document.getElementById('toolbar-right');
        if (existingRight) {
            existingRight.remove();
        }
        
        // Create toolbar element
        rightToolbar = document.createElement('nav');
        rightToolbar.id = 'toolbar-right';
        rightToolbar.className = 'toolbar toolbar-right toolbar-global';
        rightToolbar.setAttribute('role', 'toolbar');
        rightToolbar.setAttribute('aria-label', 'Global controls');
        
        // Render buttons
        safeSetInnerHTML(rightToolbar, renderToolbarButtons(activeRightButtons));
        
        // Insert into container
        if (container.id === 'toolbar-container') {
            container.appendChild(rightToolbar);
        } else {
            // Insert after left toolbar in .graph-explorer
            const graphExplorer = container.querySelector ? container : document.querySelector('.graph-explorer');
            if (graphExplorer) {
                graphExplorer.appendChild(rightToolbar);
            }
        }
        
        // Create Lucide icons if available
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 10);
        }
        
        console.log('[ExplorerToolbar] Created right toolbar dynamically');
    }

    // ============================================
    // Toolbar Creation
    // ============================================
    function createToolbars() {
        leftToolbar = document.getElementById('toolbar-left');

        if (leftToolbar) {
            safeSetInnerHTML(leftToolbar, renderToolbarButtons(activeLeftButtons));
        }
        
        // Also recreate right toolbar
        createRightToolbar();
    }

    function renderToolbarButtons(sections) {
        let html = '';
        
        sections.forEach((section, sectionIdx) => {
            // Add divider between sections (with appropriate class)
            if (sectionIdx > 0) {
                const dividerClass = section.sectionClass || '';
                const hiddenStyle = section.hidden ? ' style="display: none;"' : '';
                html += `<div class="toolbar-divider ${dividerClass}"${hiddenStyle}></div>`;
            }
            
            // Section container with visibility class
            const sectionClass = section.sectionClass || '';
            const hiddenStyle = section.hidden ? ' style="display: none;"' : '';
            const sectionId = section.section ? `id="toolbar-section-${section.section}"` : '';
            html += `<div ${sectionId} class="toolbar-section ${sectionClass}"${hiddenStyle}>`;
            
            // Handle dynamic checkpoints section
            if (section.section === 'checkpoints-list') {
                html += renderCheckpointsList();
            }
            // Handle dynamic bookmarks section  
            else if (section.section === 'bookmarks-list') {
                html += renderBookmarksList();
            }
            // Handle dynamic timelines list section
            else if (section.section === 'timelines-list') {
                html += renderTimelinesList();
            }
            // Handle dynamic analytics list section
            else if (section.section === 'analytics-list') {
                html += renderAnalyticsList();
            }
            // Regular buttons
            else {
                section.buttons.forEach(btn => {
                    // Skip hidden buttons
                    if (btn.hidden) return;
                    
                    const activeClass = btn.active ? ' active' : '';
                    const warningClass = btn.warning ? ' warning' : '';
                    html += `
                        <button 
                            type="button"
                            id="${btn.id}"
                            class="toolbar-btn toolbar-btn-with-label${activeClass}${warningClass}"
                            data-action="${btn.action}"
                            data-tooltip="${btn.label}"
                            data-shortcut="${btn.shortcut || ''}"
                            ${btn.toggle ? 'data-toggle="true"' : ''}
                            ${btn.group ? `data-group="${btn.group}"` : ''}
                            ${btn.panel ? `data-panel="${btn.panel}"` : ''}
                            aria-label="${btn.label}"
                            aria-pressed="${btn.active ? 'true' : 'false'}"
                            ${btn.toggle ? 'aria-haspopup="dialog"' : ''}
                            role="button"
                            tabindex="0"
                        >
                            <i data-lucide="${btn.icon}"></i>
                            <span class="toolbar-btn-label">${btn.label}</span>
                        </button>
                    `;
                });
            }
            
            html += '</div>';
        });
        
        return html;
    }
    
    /**
     * Render the dynamic checkpoints list for the toolbar
     */
    function renderCheckpointsList() {
        if (!checkpointsList || checkpointsList.length === 0) {
            return '<div class="toolbar-empty-list">No checkpoints</div>';
        }
        
        return checkpointsList.map((cp, idx) => `
            <button 
                type="button"
                class="toolbar-btn toolbar-btn-with-label toolbar-checkpoint-item"
                data-action="restoreCheckpoint"
                data-checkpoint="${escapeHtml(cp.name || cp)}"
                data-tooltip="Restore: ${escapeHtml(cp.name || cp)}"
                aria-label="Restore checkpoint: ${escapeHtml(cp.name || cp)}"
                role="button"
                tabindex="0"
            >
                <i data-lucide="flag"></i>
                <span class="toolbar-btn-label">${escapeHtml(cp.name || cp)}</span>
            </button>
        `).join('');
    }
    
    /**
     * Render the dynamic bookmarks list for the toolbar
     */
    function renderBookmarksList() {
        if (!bookmarksList || bookmarksList.length === 0) {
            return '<div class="toolbar-empty-list">No bookmarks</div>';
        }
        
        return bookmarksList.map((bm, idx) => `
            <button 
                type="button"
                class="toolbar-btn toolbar-btn-with-label toolbar-bookmark-item"
                data-action="useBookmark"
                data-bookmark="${escapeHtml(bm.name || bm)}"
                data-tooltip="Load: ${escapeHtml(bm.name || bm)}"
                aria-label="Load bookmark: ${escapeHtml(bm.name || bm)}"
                role="button"
                tabindex="0"
            >
                <i data-lucide="bookmark"></i>
                <span class="toolbar-btn-label">${escapeHtml(bm.name || bm)}</span>
            </button>
        `).join('');
    }
    
    /**
     * Render the dynamic timelines list for the toolbar
     */
    function renderTimelinesList() {
        if (!timelinesList || timelinesList.length === 0) {
            return '<div class="toolbar-empty-list">No timelines</div>';
        }
        
        return timelinesList.map((tl, idx) => `
            <button 
                type="button"
                class="toolbar-btn toolbar-btn-with-label toolbar-timeline-item"
                data-action="focusTimeline"
                data-timeline-id="${escapeHtml(tl.id)}"
                data-tooltip="View: ${escapeHtml(tl.name)}"
                aria-label="View timeline: ${escapeHtml(tl.name)}"
                role="button"
                tabindex="0"
            >
                <i data-lucide="clock"></i>
                <span class="toolbar-btn-label">${escapeHtml(tl.name)}</span>
            </button>
        `).join('');
    }
    
    /**
     * Render the dynamic analytics list for the toolbar
     */
    function renderAnalyticsList() {
        if (!analyticsList || analyticsList.length === 0) {
            return '<div class="toolbar-empty-list">No analytics</div>';
        }
        
        return analyticsList.map((an, idx) => `
            <button 
                type="button"
                class="toolbar-btn toolbar-btn-with-label toolbar-analytics-item"
                data-action="focusAnalytics"
                data-analytics-id="${escapeHtml(an.id)}"
                data-tooltip="View: ${escapeHtml(an.name)}"
                aria-label="View analytics: ${escapeHtml(an.name)}"
                role="button"
                tabindex="0"
            >
                <i data-lucide="bar-chart-2"></i>
                <span class="toolbar-btn-label">${escapeHtml(an.name)}</span>
            </button>
        `).join('');
    }
    
    /**
     * Update the checkpoints list and re-render the section
     */
    function updateCheckpointsList(checkpoints) {
        checkpointsList = checkpoints || [];
        const section = document.getElementById('toolbar-section-checkpoints-list');
        if (section) {
            safeSetInnerHTML(section, renderCheckpointsList());
            if (typeof lucide !== 'undefined') {
                lucide.createIcons();
            }
            // Rebind events for new buttons
            bindDynamicListEvents();
        }
    }
    
    /**
     * Update the bookmarks list and re-render the section
     */
    function updateBookmarksList(bookmarks) {
        bookmarksList = bookmarks || [];
        const section = document.getElementById('toolbar-section-bookmarks-list');
        if (section) {
            safeSetInnerHTML(section, renderBookmarksList());
            if (typeof lucide !== 'undefined') {
                lucide.createIcons();
            }
            // Rebind events for new buttons
            bindDynamicListEvents();
        }
    }
    
    /**
     * Update the timelines list and re-render the section
     */
    function updateTimelinesList(timelines) {
        timelinesList = timelines || [];
        const section = document.getElementById('toolbar-section-timelines-list');
        if (section) {
            safeSetInnerHTML(section, renderTimelinesList());
            if (typeof lucide !== 'undefined') {
                lucide.createIcons();
            }
            // Rebind events for new buttons
            bindDynamicListEvents();
        }
    }
    
    /**
     * Add a single timeline to the list
     */
    function addTimelineToList(id, name) {
        timelinesList.push({ id, name });
        updateTimelinesList(timelinesList);
    }
    
    /**
     * Remove a timeline from the list
     */
    function removeTimelineFromList(id) {
        timelinesList = timelinesList.filter(t => t.id !== id);
        updateTimelinesList(timelinesList);
    }
    
    /**
     * Update a timeline name in the list
     */
    function updateTimelineInList(id, newName) {
        const timeline = timelinesList.find(t => t.id === id);
        if (timeline) {
            timeline.name = newName;
            updateTimelinesList(timelinesList);
        }
    }
    
    /**
     * Update the analytics list and re-render the section
     */
    function updateAnalyticsList(analytics) {
        analyticsList = analytics || [];
        const section = document.getElementById('toolbar-section-analytics-list');
        if (section) {
            safeSetInnerHTML(section, renderAnalyticsList());
            if (typeof lucide !== 'undefined') {
                lucide.createIcons();
            }
            // Rebind events for new buttons
            bindDynamicListEvents();
        }
    }
    
    /**
     * Add a single analytics query to the list
     */
    function addAnalyticsToList(id, name) {
        analyticsList.push({ id, name });
        updateAnalyticsList(analyticsList);
    }
    
    /**
     * Remove an analytics query from the list
     */
    function removeAnalyticsFromList(id) {
        analyticsList = analyticsList.filter(a => a.id !== id);
        updateAnalyticsList(analyticsList);
    }
    
    /**
     * Update an analytics name in the list
     */
    function updateAnalyticsInList(id, newName) {
        const analytics = analyticsList.find(a => a.id === id);
        if (analytics) {
            analytics.name = newName;
            updateAnalyticsList(analyticsList);
        }
    }
    
    /**
     * Add a single artefact to the list
     */
    function addArtefactToList(id, name) {
        artefactsList.push({ id, name });
        // Note: artefactsList is tracked but not rendered in left toolbar currently
        console.log(`[ExplorerToolbar] Added artefact: ${name} (${id})`);
    }
    
    /**
     * Remove an artefact from the list
     */
    function removeArtefactFromList(id) {
        artefactsList = artefactsList.filter(a => a.id !== id);
        console.log(`[ExplorerToolbar] Removed artefact: ${id}`);
    }
    
    /**
     * Update an artefact name in the list
     */
    function updateArtefactInList(id, newName) {
        const artefact = artefactsList.find(a => a.id === id);
        if (artefact) {
            artefact.name = newName;
            console.log(`[ExplorerToolbar] Updated artefact: ${newName} (${id})`);
        }
    }
    
    /**
     * Bind events to dynamic list items (checkpoints/bookmarks/timelines/analytics)
     */
    function bindDynamicListEvents() {
        // Checkpoint items
        document.querySelectorAll('.toolbar-checkpoint-item').forEach(btn => {
            btn.removeEventListener('click', handleCheckpointClick);
            btn.addEventListener('click', handleCheckpointClick);
        });
        
        // Bookmark items
        document.querySelectorAll('.toolbar-bookmark-item').forEach(btn => {
            btn.removeEventListener('click', handleBookmarkClick);
            btn.addEventListener('click', handleBookmarkClick);
        });
        
        // Timeline items
        document.querySelectorAll('.toolbar-timeline-item').forEach(btn => {
            btn.removeEventListener('click', handleTimelineClick);
            btn.addEventListener('click', handleTimelineClick);
        });
        
        // Analytics items
        document.querySelectorAll('.toolbar-analytics-item').forEach(btn => {
            btn.removeEventListener('click', handleAnalyticsClick);
            btn.addEventListener('click', handleAnalyticsClick);
        });
    }
    
    function handleCheckpointClick(e) {
        const name = e.currentTarget.dataset.checkpoint;
        if (name && typeof ExplorerAPI !== 'undefined' && ExplorerAPI.executeMQL) {
            // Sync active state to bottom bar immediately
            if (typeof ExplorerTabs !== 'undefined' && ExplorerTabs.setCheckpoints) {
                ExplorerTabs.setCheckpoints(undefined, name);
            }
            const query = `RESTORE('${name.replace(/'/g, "''")}');`;
            ExplorerAPI.executeMQL(query).then(() => {
                if (ExplorerAPI.refreshGraph) {
                    ExplorerAPI.refreshGraph(true);
                }
            }).catch(err => {
                console.error('[ExplorerToolbar] Failed to restore checkpoint:', err);
            });
        }
    }
    
    function handleBookmarkClick(e) {
        const name = e.currentTarget.dataset.bookmark;
        if (!name || typeof ExplorerAPI === 'undefined') return;

        if (typeof ExplorerTabs !== 'undefined' && ExplorerTabs.setBookmarks) {
            ExplorerTabs.setBookmarks(undefined, name);
        }

        if (ExplorerAPI.previewPointerGraph) {
            ExplorerAPI.previewPointerGraph('bookmark', name, { switchTab: false }).catch((err) => {
                console.error('[ExplorerToolbar] Failed to preview bookmark:', err);
            });
            return;
        }

        if (!ExplorerAPI.executeMQL) return;

        const query = `USE BOOKMARK('${name.replace(/'/g, "''")}');`;
        ExplorerAPI.executeMQL(query).then(() => {
            if (ExplorerAPI.refreshGraph) {
                ExplorerAPI.refreshGraph(true);
            }
        }).catch(err => {
            console.error('[ExplorerToolbar] Failed to use bookmark:', err);
        });
    }
    
    function handleTimelineClick(e) {
        const timelineId = e.currentTarget.dataset.timelineId;
        if (timelineId && typeof ExplorerTabs !== 'undefined' && ExplorerTabs.focusTimelineWindow) {
            ExplorerTabs.focusTimelineWindow(timelineId);
        }
    }
    
    function handleAnalyticsClick(e) {
        const analyticsId = e.currentTarget.dataset.analyticsId;
        if (analyticsId && typeof ExplorerTabs !== 'undefined' && ExplorerTabs.focusAnalyticsWindow) {
            ExplorerTabs.focusAnalyticsWindow(analyticsId);
        }
    }
    
    /**
     * Escape HTML to prevent XSS
     */
    function escapeHtml(text) {
        if (!text) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // ============================================
    // Hamburger Menu (Mobile)
    // ============================================
    function createHamburgerMenu() {
        hamburgerBtn = document.getElementById('hamburger-btn');
        
        if (!hamburgerBtn) {
            // Create if doesn't exist
            const container = document.querySelector('.graph-explorer');
            if (container) {
                hamburgerBtn = document.createElement('button');
                hamburgerBtn.id = 'hamburger-btn';
                hamburgerBtn.className = 'hamburger-btn';
                hamburgerBtn.setAttribute('aria-label', 'Open menu');
                safeSetInnerHTML(hamburgerBtn, '<svg viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="currentColor"/></svg>');
                container.appendChild(hamburgerBtn);
            }
        }
    }

    function toggleDrawer() {
        drawerOpen = !drawerOpen;
        const toolbar = document.querySelector('.toolbar-right') || document.querySelector('.toolbar-left');
        
        if (toolbar) {
            toolbar.classList.toggle('open', drawerOpen);
        }
        
        hamburgerBtn?.setAttribute('aria-expanded', drawerOpen.toString());
    }

    // ============================================
    // Event Handling
    // ============================================
    function bindEvents() {
        // Prevent duplicate event binding on reinit
        if (eventsBound) {
            return;
        }
        eventsBound = true;
        
        // Toolbar button clicks
        document.addEventListener('click', function(e) {
            const btn = e.target.closest('.toolbar-btn');
            if (btn) {
                handleButtonClick(btn);
            }
            
            // Hamburger menu
            if (e.target.closest('.hamburger-btn')) {
                toggleDrawer();
            }
            
            // Close drawer on outside click (mobile)
            if (drawerOpen && !e.target.closest('.toolbar') && !e.target.closest('.hamburger-btn')) {
                toggleDrawer();
            }
        });
    }

    function handleButtonClick(btn) {
        const action = btn.dataset.action;
        const isToggle = btn.dataset.toggle === 'true';
        const group = btn.dataset.group;

        // Handle toggle buttons
        if (isToggle) {
            if (group) {
                // Radio group - only one active
                document.querySelectorAll(`[data-group="${group}"]`).forEach(b => {
                    b.classList.remove('active');
                    b.setAttribute('aria-pressed', 'false');
                });
            }
            btn.classList.toggle('active');
            btn.setAttribute('aria-pressed', btn.classList.contains('active').toString());
        }

        // Execute action
        executeAction(action, btn);
    }

    function executeAction(action, btn) {
        switch (action) {
            case 'clearView':
                // Clear selection without removing checkpoints/bookmarks
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.clearGraph) {
                    console.log('[ExplorerToolbar] Clearing graph view (preserving checkpoints/bookmarks)...');
                    ExplorerAPI.clearGraph().then(function() {
                        console.log('[ExplorerToolbar] Graph view cleared');
                        // NOTE: vis.js clearing and empty state are handled inside clearGraph()
                        // NOTE: Do NOT clear checkpoints/bookmarks lists – they are preserved
                    }).catch(function(err) {
                        console.error('[ExplorerToolbar] Clear failed:', err);
                    });
                }
                break;
            case 'reset':
                // Full cursor reset: clear backend state + clear graph + show empty state
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.resetMeCursor) {
                    console.log('[ExplorerToolbar] Resetting cursor and clearing graph...');
                    ExplorerAPI.resetMeCursor().then(function() {
                        console.log('[ExplorerToolbar] Cursor reset successful');
                        // Clear the graph nodes and edges
                        if (typeof GraphExplorer !== 'undefined' && GraphExplorer.state) {
                            if (GraphExplorer.state.nodes) {
                                GraphExplorer.state.nodes.clear();
                            }
                            if (GraphExplorer.state.edges) {
                                GraphExplorer.state.edges.clear();
                            }
                            // Show empty state overlay (use showEmptyState directly since we know it's empty)
                            if (GraphExplorer.showEmptyState) {
                                GraphExplorer.showEmptyState();
                            }
                        }
                        // Also update aliases list to empty
                        if (ExplorerAPI.updateAliasesList) {
                            ExplorerAPI.updateAliasesList([]);
                        }
                        // Clear checkpoints and bookmarks lists in the toolbar
                        updateCheckpointsList([]);
                        updateBookmarksList([]);
                        // Also clear in ExplorerWindows if available
                        if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.clearCheckpointsAndBookmarks) {
                            ExplorerWindows.clearCheckpointsAndBookmarks();
                        }
                        // Refresh FQL history panel (should now be empty)
                        if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.loadFqlHistory) {
                            ExplorerWindows.loadFqlHistory();
                        }
                        console.log('[ExplorerToolbar] Graph cleared, checkpoints and bookmarks cleared');
                    }).catch(function(err) {
                        console.error('[ExplorerToolbar] Reset failed:', err);
                    });
                } else if (typeof resetToCheckpoint === 'function') {
                    resetToCheckpoint();
                }
                break;
            case 'reload':
                // Use ExplorerAPI for dynamic graph refresh
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.refreshGraph) {
                    ExplorerAPI.refreshGraph().then(function(success) {
                        if (success) {
                            console.log('[ExplorerToolbar] Graph reloaded successfully');
                        } else {
                            console.warn('[ExplorerToolbar] Graph reload returned false');
                        }
                    }).catch(function(err) {
                        console.error('[ExplorerToolbar] Graph reload failed:', err);
                    });
                } else if (typeof reloadGraph === 'function') {
                    // Fallback to legacy reload function
                    reloadGraph();
                } else {
                    console.warn('[ExplorerToolbar] No reload function available');
                }
                break;
            case 'rebuild':
                // Full server-side graph rebuild + cache invalidation + reload
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.rebuildGraph) {
                    // Disable button and show spinner while rebuilding
                    btn.disabled = true;
                    btn.classList.add('btn-loading');
                    ExplorerAPI.rebuildGraph().then(function(success) {
                        if (success) {
                            console.log('[ExplorerToolbar] Graph rebuilt successfully');
                        } else {
                            console.warn('[ExplorerToolbar] Graph rebuild returned false');
                        }
                    }).catch(function(err) {
                        console.error('[ExplorerToolbar] Graph rebuild failed:', err);
                    }).finally(function() {
                        btn.disabled = false;
                        btn.classList.remove('btn-loading');
                    });
                } else {
                    console.warn('[ExplorerToolbar] No rebuildGraph function available');
                }
                break;
            case 'extendedEdges':
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.setExtendedEdges) {
                    const isPressed = btn.getAttribute('aria-pressed') === 'true';
                    const newState = !isPressed;
                    btn.setAttribute('aria-pressed', String(newState));
                    ExplorerAPI.setExtendedEdges(newState);
                    ExplorerAPI.refreshGraph(true);
                }
                break;
            case 'theme':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleTheme) {
                    const theme = GraphExplorer.toggleTheme();
                    const iconText = btn.querySelector('.icon-text');
                    if (iconText) iconText.textContent = theme === 'dark' ? '☾' : '☀';
                    // Sync theme to chat panel
                    if (window.ExplorerChat?.setChatTheme) {
                        window.ExplorerChat.setChatTheme(theme);
                    }
                }
                break;
            case 'nodeLabels':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleNodeLabels) {
                    GraphExplorer.toggleNodeLabels();
                }
                break;
            case 'edgeLabels':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.toggleEdgeLabels) {
                    GraphExplorer.toggleEdgeLabels();
                }
                break;
            case 'physics':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.togglePhysics) {
                    GraphExplorer.togglePhysics();
                }
                break;
            case 'performanceMode':
                if (typeof ExplorerAPI !== 'undefined' && ExplorerAPI.togglePerformanceMode) {
                    const mode = ExplorerAPI.togglePerformanceMode();
                    setButtonActive('btn-performance-mode', mode === 'large');
                    ExplorerAPI.refreshGraph(true).catch(function(err) {
                        console.error('[ExplorerToolbar] Performance mode refresh failed:', err);
                    });
                }
                break;
            case 'layout':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.improveLayout) {
                    GraphExplorer.improveLayout();
                }
                break;
            case 'fit':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.fitToScreen) {
                    GraphExplorer.fitToScreen();
                }
                break;
            case 'cluster':
                if (typeof ExplorerClustering !== 'undefined') {
                    if (ExplorerClustering.enabled) {
                        ExplorerClustering.expandAll();
                        _updateClusterButton(false);
                    } else {
                        var attr = (typeof GraphExplorer !== 'undefined' && GraphExplorer.state)
                            ? GraphExplorer.state.currentColorAttribute || 'resource_name'
                            : 'resource_name';
                        ExplorerClustering.clusterByAttribute(attr);
                        _updateClusterButton(true);
                    }
                }
                break;

            case 'singleSelect':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.setSelectionMode) {
                    GraphExplorer.setSelectionMode('single');
                }
                break;
            case 'multiSelect':
                if (typeof GraphExplorer !== 'undefined' && GraphExplorer.setSelectionMode) {
                    GraphExplorer.setSelectionMode('multi');
                }
                break;
            // Node actions - open modal
            case 'extend':
            case 'connect':
            case 'map':
            case 'intersect':
            case 'differs':
            case 'union':
            case 'isolate':
            case 'remove':
                ExplorerModal.open(action);
                break;
            case 'color':
            case 'colorPanel':
                ExplorerPanels.open('color');
                break;
            case 'size':
            case 'sizePanel':
                ExplorerPanels.open('size');
                break;
            case 'settingsWindow':
                ExplorerWindows.toggle('settings');
                break;
            case 'filter':
            case 'filterPanel':
                ExplorerPanels.open('filter');
                break;
            case 'explorerWindow':
                ExplorerWindows.toggle('explorer');
                break;
            case 'searchWindow':
                // Legacy: redirect to explorer window
                ExplorerWindows.toggle('explorer');
                break;
            case 'checkpointsWindow':
                ExplorerWindows.toggle('checkpoints');
                break;
            case 'patternsWindow':
                ExplorerWindows.toggle('patterns');
                break;
            case 'createCheckpoint':
                showCreateCheckpointPrompt();
                break;
            case 'createBookmark':
                showCreateBookmarkPrompt();
                break;
            case 'findWindow':
                // Legacy: redirect to explorer window with find tab
                ExplorerWindows.toggle('explorer');
                break;
            case 'findSelectWindow':
                ExplorerWindows.toggle('findSelect');
                break;
            case 'aliasesWindow':
                ExplorerWindows.toggle('aliases');
                break;
            case 'selectionWindow':
                ExplorerWindows.toggle('selection');
                break;
            case 'detailsWindow':
                // Legacy: redirect to selection window
                ExplorerWindows.toggle('selection');
                break;
            case 'operatorsWindow':
                // Legacy: redirect to selection window
                ExplorerWindows.toggle('selection');
                break;
            case 'algorithmsWindow':
                ExplorerWindows.toggle('algorithms');
                break;
            case 'functionsWindow':
                ExplorerWindows.toggle('functions');
                break;
            case 'documentsWindow':
                ExplorerWindows.toggle('documents');
                break;
            case 'legendWindow':
                ExplorerWindows.toggle('legend');
                break;
            case 'fqlWindow':
                ExplorerWindows.toggle('fql');
                break;
            case 'timeline':
                ExplorerTimeline.toggle();
                break;
            // Polling and API key actions removed
            case 'hubs':
            case 'toggleHubs':
                if (typeof toggleInfluentialNodes === 'function') toggleInfluentialNodes();
                break;
            case 'algorithm':
            case 'algorithmPanel':
                ExplorerPanels.open('algorithm');
                break;
            case 'aliases':
            case 'aliasesPanel':
                ExplorerPanels.open('aliases');
                break;
            case 'export':
            case 'exportPanel':
                ExplorerPanels.open('export');
                break;
            case 'checkpoint':
            case 'checkpointPanel':
                ExplorerPanels.open('checkpoint');
                break;
            case 'contextPanel':
                ExplorerPanels.toggleContext();
                break;
            case 'createTimeline':
                if (typeof ExplorerTabs !== 'undefined' && ExplorerTabs.createTimelineWindow) {
                    ExplorerTabs.createTimelineWindow();
                }
                break;
            case 'createAnalytics':
                if (typeof ExplorerTabs !== 'undefined' && ExplorerTabs.createAnalyticsWindow) {
                    ExplorerTabs.createAnalyticsWindow();
                }
                break;
            case 'browseTemplates':
                // Switch to Artefacts tab first, then open Templates window after DOM updates
                if (typeof ExplorerTabs !== 'undefined') {
                    ExplorerTabs.switchTab('artefacts');
                    // Wait for tab content to render before opening the window
                    requestAnimationFrame(() => {
                        if (typeof ExplorerWindows !== 'undefined') {
                            ExplorerWindows.toggle('templates');
                        }
                    });
                }
                break;
        }
    }
    
    // ============================================
    // Create Checkpoint/Bookmark Prompts
    // ============================================
    
    /**
     * Show prompt to create a new checkpoint
     */
    function showCreateCheckpointPrompt() {
        const name = prompt('Enter checkpoint name:');
        if (name && name.trim()) {
            createCheckpoint(name.trim());
        }
    }
    
    /**
     * Show prompt to create a new bookmark
     */
    function showCreateBookmarkPrompt() {
        const name = prompt('Enter bookmark name:');
        if (name && name.trim()) {
            createBookmark(name.trim());
        }
    }
    
    /**
     * Create a checkpoint via FQL
     */
    async function createCheckpoint(name) {
        if (typeof ExplorerAPI === 'undefined' || !ExplorerAPI.executeMQL) {
            console.error('[ExplorerToolbar] API not available');
            return;
        }
        
        try {
            const query = `CHECKPOINT('${name.replace(/'/g, "''")}');`;
            await ExplorerAPI.executeMQL(query);
            console.log(`[ExplorerToolbar] Checkpoint "${name}" created`);
            
            // Refresh the checkpoints list and mark the new one as active
            loadCheckpointsAndBookmarks(name, null);
            
            // Refresh FQL history
            if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.loadFqlHistory) {
                ExplorerWindows.loadFqlHistory();
            }
        } catch (err) {
            console.error('[ExplorerToolbar] Failed to create checkpoint:', err);
            alert(`Failed to create checkpoint: ${err.message}`);
        }
    }
    
    /**
     * Create a bookmark via FQL
     */
    async function createBookmark(name) {
        if (typeof ExplorerAPI === 'undefined' || !ExplorerAPI.executeMQL) {
            console.error('[ExplorerToolbar] API not available');
            return;
        }
        
        try {
            const query = `CREATE BOOKMARK('${name.replace(/'/g, "''")}');`;
            await ExplorerAPI.executeMQL(query);
            console.log(`[ExplorerToolbar] Bookmark "${name}" created`);
            
            // Refresh the bookmarks list and mark the new one as active
            loadCheckpointsAndBookmarks(null, name);
            
            // Refresh FQL history
            if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.loadFqlHistory) {
                ExplorerWindows.loadFqlHistory();
            }
        } catch (err) {
            console.error('[ExplorerToolbar] Failed to create bookmark:', err);
            alert(`Failed to create bookmark: ${err.message}`);
        }
    }
    
    /**
     * Load checkpoints and bookmarks from cursor state
     */
    async function loadCheckpointsAndBookmarks(activeCheckpoint, activeBookmark) {
        if (typeof ExplorerAPI === 'undefined' || !ExplorerAPI.isConfigured || !ExplorerAPI.isConfigured()) {
            return;
        }
        
        try {
            const config = ExplorerAPI.getConfig ? ExplorerAPI.getConfig() : {};
            const apiEndpoint = config.apiEndpoint || '';
            const workspaceId = config.workspaceId;
            const cursorId = config.cursorId || 'me';
            
            if (!workspaceId) return;
            
            const url = `${apiEndpoint}/workspaces/${workspaceId}/cursors/${cursorId}/state`;
            const headers = { 'Accept': 'application/json' };
            
            if (ExplorerAPI.getAuthHeaders) {
                Object.assign(headers, ExplorerAPI.getAuthHeaders());
            }
            
            const fetchOptions = { method: 'GET', headers };
            if (ExplorerAPI.shouldIncludeCredentials && ExplorerAPI.shouldIncludeCredentials()) {
                fetchOptions.credentials = 'include';
            }
            
            const response = await fetch(url, fetchOptions);
            
            if (response.ok) {
                const state = await response.json();
                
                // Update checkpoints (array of objects with 'name' property)
                const rawCheckpoints = state.checkpoints || [];
                const checkpointsArray = Array.isArray(rawCheckpoints)
                    ? rawCheckpoints.map(cp => ({ name: cp.name || cp }))
                    : Object.keys(rawCheckpoints).map(name => ({ name }));
                updateCheckpointsList(checkpointsArray);
                
                // Update bookmarks (array of objects with 'name' property)
                const rawBookmarks = state.bookmarks || [];
                const bookmarksArray = Array.isArray(rawBookmarks)
                    ? rawBookmarks.map(bm => ({ name: bm.name || bm }))
                    : Object.keys(rawBookmarks).map(name => ({ name }));
                updateBookmarksList(bookmarksArray);
                
                // Push to bottom sub-tabs bar
                if (typeof ExplorerTabs !== 'undefined') {
                    if (ExplorerTabs.setCheckpoints) ExplorerTabs.setCheckpoints(checkpointsArray, activeCheckpoint);
                    if (ExplorerTabs.setBookmarks) ExplorerTabs.setBookmarks(bookmarksArray, activeBookmark);
                }
                
                // Also update the window panel from pre-fetched state
                // (avoids a redundant /state fetch from ExplorerWindows)
                if (typeof ExplorerWindows !== 'undefined' && ExplorerWindows.updateStateData) {
                    ExplorerWindows.updateStateData(state);
                }
            }
        } catch (err) {
            console.warn('[ExplorerToolbar] Failed to load checkpoints/bookmarks:', err);
        }
    }

    // ============================================
    // Button State Updates
    // ============================================
    function setButtonActive(buttonId, active) {
        const btn = document.getElementById(buttonId);
        if (btn) {
            btn.classList.toggle('active', active);
            btn.setAttribute('aria-pressed', active.toString());
        }
    }

    function updateButtonIcon(buttonId, icon) {
        const btn = document.getElementById(buttonId);
        if (btn) {
            const iconEl = btn.querySelector('.icon-text');
            if (iconEl) iconEl.textContent = icon;
        }
    }
    
    /**
     * Update the cluster button active state
     */
    function _updateClusterButton(active) {
        setButtonActive('btn-cluster', active);
    }

    // ============================================
    // Public API
    // ============================================
    global.ExplorerToolbar = {
        init,
        setButtonActive,
        updateButtonIcon,
        toggleDrawer,
        updateCheckpointsList,
        updateBookmarksList,
        updateTimelinesList,
        updateAnalyticsList,
        addTimelineToList,
        removeTimelineFromList,
        updateTimelineInList,
        addAnalyticsToList,
        removeAnalyticsFromList,
        updateAnalyticsInList,
        addArtefactToList,
        removeArtefactFromList,
        updateArtefactInList,
        loadCheckpointsAndBookmarks
    };

})(window);
